<template>
  <el-table
    :row-class-name="tableRowClassName"
    ref="BaseTable"
    :data="list || []"
    tooltip-effect="light"
    v-loading="loading"
    v-bind="$attrs"
    v-on="$listeners"
    class="new-base-table"
    :span-method="expandable ? arraySpanMethod : spanMethod"
    :element-loading-text="$t('common.loadingEllipsis')"
    element-loading-spinner="el-icon-loading"
    @expand-change="expandChange"
    @sort-change="handleSortChange"
  >
    <template v-for="(column, index) in columns">
      <slot name="front-slot"></slot>
      <!-- 复选框  -->
      <el-table-column
        :key="index"
        v-if="column.type === 'selection'"
        type="selection"
        :width="column.width || 46"
        align="center"
      ></el-table-column>
      <!--序号-->
      <el-table-column
        :key="index"
        v-else-if="column.type === 'index'"
        type="index"
        :width="column.width || 74"
        :label="column.title || $t('common.serialNumber')"
        :align="column.align || 'center'"
      >
      </el-table-column>
      <!-- 具体内容 -->
      <el-table-column
        :key="index"
        v-else
        :align="column.align || 'left'"
        :sortable="column.sortable"
        :show-overflow-tooltip="true"
        :label="column.title"
        :width="column.type === 'operate' ? column.width : ''"
        :min-width="column.type !== 'operate' ? column.width : ''"
        :class-name="column.title === $t('common.action') ? 'operationColumn' : ''"
        :formatter="column.formatter"
        :resizable="false"
      >
        <template slot-scope="scope">
          <!-- 仅仅显示文字 -->
          <template v-if="!column.hidden">
            <!-- 如果hidden为true的时候 那么当前格可以不显示，可以选择显示自定义的slot-->
            <!-- 操作按钮 -->
            <template v-if="column.type === 'operate'">
              <slot name="operate" :scope="scope"></slot>
              <a
                href="javascript:void(0)"
                class="operate-button"
                v-for="(operate, operateIndex) in filterOperateList(column, scope.row)"
                :class="{ disabled: operate.disabledFilter && operate.disabledFilter(scope.row) }"
                :key="operateIndex"
                @click="handleClick(operate, scope.row)"
              >
                {{
                  operate.transFilter ? operate.transFilter(scope.row[operate.key]) : operate.name
                }}
                <template v-if="operate.emitKey === 'expand'">
                  <img
                    v-if="!(operate.disabledFilter && operate.disabledFilter(scope.row))"
                    src="@/assets/i-toggle.png"
                    class="i-toggle"
                    :class="{ up: expandedRows.some((item) => item.id === scope.row.id) }"
                  />
                  <img v-else src="@/assets/i-toggle-disabled.png" class="i-toggle disabled" />
                </template>
              </a>
              <template v-if="!filterOperateList(column, scope.row).length">--</template>
            </template>
            <!-- 如果有自定义的handler函数 -->
            <span v-else :class="column.classList && column.classList(scope.row)">{{
              takeOutValue(column, scope.row) | emptyText
            }}</span>
          </template>
          <!-- 使用slot的情况下 -->
          <slot v-if="column.slot" :name="column.slot" :row="scope.row"></slot>
        </template>
      </el-table-column>
    </template>
    <!-- 展开行 -->
    <el-table-column key="expand" v-if="expandable" type="expand">
      <template slot-scope="scope">
        <slot name="expand" :row="scope.row"></slot>
      </template>
    </el-table-column>
    <!--默认的slot -->
    <slot />
  </el-table>
</template>
<script>
import { searchAuthInPermission } from '@/utils/index';
export default {
  name: 'new-base-table',
  props: {
    list: {
      // 表格数据
      type: Array,
      default: function () {
        return [];
      },
    },
    columns: {
      // headers列
      type: Array,
      required: true,
      default: function () {
        return [];
      },
    },
    loading: {
      // loading状态
      type: Boolean,
      default: false,
    },
    spanMethod: {
      type: Function,
      default: function () {
        return () => {};
      },
    },
    tableRowClassName: {
      type: Function,
      default: function () {
        return () => '';
      },
    },
  },
  data() {
    return {
      expandedRows: [], // 展开的行列表
    };
  },
  computed: {
    expandable() {
      // 是否可以操作,为false则不显示操作按钮
      const operationColum = this.columns.find((item) => item.type === 'operate');
      return operationColum && operationColum.operates.some((item) => item.emitKey === 'expand');
    },
  },
  watch: {
    list(listData) {
      if (listData && listData.length && this.expandedRows.length) {
        this.$nextTick(() => {
          this.expandedRows.map((item) => {
            const row = listData.find((rowItem) => rowItem.id === item.id);
            if (row) {
              this.$refs.BaseTable.toggleRowExpansion(row, false);
            }
          });
        });
      }
    },
  },
  methods: {
    // 根据每行的状态过滤操作按钮
    filterOperateList({ operates, operateFilter }, row) {
      return operates.filter((item) => {
        // 如果不需要权限控制
        if (!item.authUrl) return true;
        // 是否有权限
        const isHasAuth = searchAuthInPermission(item.authUrl);
        // 是否有已定义过滤函数
        if (operateFilter) {
          return operateFilter(row, item, isHasAuth);
        }
        return isHasAuth;
      });
    },
    takeOutValue({ handler, key, valueType }, row) {
      // 如果有自定义处理函数的话
      if (handler) {
        return handler(row);
      }
      // 所有的金额显示要保留两位小数
      if (valueType === 'money') {
        return row[key] && parseFloat(row[key]).toFixed(2);
      }
      return row[key];
    },
    searchAuthInPermission,
    handleClick({ emitKey }, data) {
      if (emitKey === 'expand') {
        this.$emit(`expanded`, data);
        return this.handleExpand(data);
      }
      this.$emit(`${emitKey}`, data);
    },
    select(selection, row) {
      this.$emit('select', selection, row);
    },
    selectAll(selection) {
      this.$emit('select-all', selection);
    },
    handleExpand(row) {
      this.$refs.BaseTable.toggleRowExpansion(row);
    },
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === this.columns.length - 1) {
        return [1, 2];
      } else if (columnIndex === this.columns.length) {
        return [0, 0];
      }
    },
    expandChange(row, expandedRows) {
      this.expandedRows = expandedRows;
    },
    handleSortChange({ column, order }) {
      this.$emit('handleSortChange', { column, order });
    },
  },
};
</script>
<style lang="scss">
@mixin columnHackStyle {
  border-right: none;

  &::after {
    content: '';
    position: absolute;
    right: -8px;
    bottom: -1px;
    width: 8px;
    height: 100%;
    display: inline-block;
    background: inherit;
    border-bottom: 1px solid #ebeef5;
  }
}

.new-base-table {
  font-size: 12px;

  th.is-leaf {
    font-size: 12px;
    // padding: 10px 0;
  }

  .cell,
  th > .cell {
    padding-left: 16px;
    padding-right: 16px;
    line-height: 1;
  }

  .operationColumn {
    @include columnHackStyle;
    overflow: hidden;
    // .cell {
    //   display: flex;
    //   justify-content: flex-end;
    // }
  }

  .el-table__expand-column {
    border-right: none;
  }

  thead {
    &::after {
      content: '';
      position: absolute;
      right: 0;
      top: 0;
      width: 6px;
      height: 36px;
      display: inline-block;
      background: #f4f5f9;
    }
  }

  .el-table__expanded-cell {
    padding: 0;
    line-height: 32px;
    border-right: none;
    @include columnHackStyle;
  }

  .inner-icon {
    width: 16px;
    height: 16px;
    margin-right: 2px;
    vertical-align: sub;
  }

  .operate-button {
    font-size: 14px;
    line-height: 1;
    color: #1f6aff;
    text-decoration: underline;
    display: inline-flex;
    align-items: center;
    padding-right: 6px;

    &:not(:only-child):not(:nth-last-of-type(1)) {
      border-right: 2px solid #bdbdc3;
      margin-right: 6px;
    }

    &:hover {
      color: #038aef;
    }

    &.disabled {
      color: #bdbdc3;
      pointer-events: none;
    }
  }

  .expand-wrapper {
    .operate-button {
      &:not(:last-child)::after {
        top: 2px;
      }
    }
  }

  .i-toggle {
    width: 16px;
    height: 11px;
    margin-left: 2px;
    transition: transform 200ms linear;
    transform: rotate(0deg);
    position: relative;
    top: 1px;

    &.up {
      transform: rotate(180deg);
    }

    &.disabled {
      width: 12px;
      height: 7px;
    }
  }

  // 报表的合并列样式
  .group-title-text {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: #333333;
    font-size: 14px;
  }

  .group-title-placeholder-text {
    display: block;
    padding: 4px 0;
    visibility: hidden;
  }

  .group-sum-title {
    white-space: nowrap;
    visibility: hidden;
  }

  .group-sum-placeholder-title {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 16px;
  }
}
.yellow-row {
  background: #fafa84 !important;
  tr {
    background: #fafa84 !important;
  }
}
</style>
